import React from "react";
import {IconUbAppleDark, IconUbAppleLight} from "@unibuddy/icons";
import {useCommunityTheme} from "ubcommunity-shared/src/Theme/CommunityThemeProvider";
import {SSOAuthButton, SSOAuthButtonText} from "./SSOAuthButton";
import {SSO_PROVIDER} from "./auth-ui/types";

type Props = {
    onClick: () => void;
    disabled?: boolean;
};

export function AppleAuthButton({disabled, onClick = () => {}}: Props) {
    const {darkModeEnabled} = useCommunityTheme();

    return (
        <SSOAuthButton
            disabled={disabled}
            onClick={onClick}
            icon={
                darkModeEnabled ? (
                    <IconUbAppleLight width={25} height={25} />
                ) : (
                    <IconUbAppleDark width={25} height={25} />
                )
            }
        >
            <SSOAuthButtonText provider={SSO_PROVIDER.APPLE} />
        </SSOAuthButton>
    );
}
